import { render, staticRenderFns } from "./UtaDashboard.vue?vue&type=template&id=bc4064d6&scoped=true&"
import script from "./UtaDashboard.vue?vue&type=script&lang=js&"
export * from "./UtaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UtaDashboard.vue?vue&type=style&index=0&id=bc4064d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4064d6",
  null
  
)

export default component.exports